// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27%3E%3Cpath fill=%27%23374151%27 d=%27M1 1l5 5 5-5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* QC Job Submitter Styles */

.job-submitter {
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  max-width: 700px;
}

.job-submitter h2 {
  margin-top: 0;
  margin-bottom: 24px;
  font-size: 20px;
  color: #1f2937;
}

.job-form {
  display: grid;
  gap: 24px;
}

/* Fieldset */
.job-submitter fieldset {
  border: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 16px;
}

.job-submitter legend {
  display: block;
  width: 100%;
  padding: 12px 0;
  margin: 0 -24px;
  padding-left: 24px;
  padding-right: 24px;
  font-weight: 600;
  font-size: 14px;
  color: #374151;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 8px;
}

/* Form Rows */
.job-submitter .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.job-submitter .form-row.single {
  grid-template-columns: 1fr;
}

.job-submitter .form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.job-submitter .form-field.full-width {
  grid-column: 1 / -1;
}

/* Labels */
.job-submitter .form-field label {
  font-weight: 500;
  font-size: 13px;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Input Fields */
.job-submitter .input-field {
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  font-family: inherit;
  transition: all 0.2s ease;
}

.job-submitter .input-field:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.job-submitter .input-field:disabled {
  background: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}

.job-submitter textarea.input-field {
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
}

.job-submitter select.input-field {
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  padding-right: 32px;
}

/* Form Buttons */
.job-submitter .form-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-start;
}

.job-submitter .btn-secondary {
  flex: 1 1;
  white-space: nowrap;
}

/* Expand Button */
.job-submitter .btn-expand {
  width: 100%;
  margin: 0;
  font-size: 13px;
  padding: 12px;
  background: white;
  color: #667eea;
  border: 1px solid #e5e7eb;
  text-align: left;
  border-radius: 6px;
}

.job-submitter .btn-expand:hover {
  background: #f9fafb;
  border-color: #667eea;
}

/* Messages */
.job-submitter .alert {
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 13px;
  margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .job-submitter {
    padding: 16px;
  }

  .job-submitter legend {
    margin-left: -16px;
    margin-right: -16px;
    padding-left: 16px;
    padding-right: 16px;
  }

  .job-submitter .form-row {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .job-submitter .form-buttons {
    flex-direction: column;
  }

  .job-submitter .btn-secondary {
    margin: 0;
  }
}

/* Inline rules editor */
.form-hint {
  margin: 0 0 12px 0;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.4;
}

.form-hint-inline {
  font-weight: normal;
  font-size: 11px;
  color: #9ca3af;
  margin-left: 6px;
}

.input-field.mono {
  font-family: 'SFMono-Regular', Menlo, Consolas, 'Liberation Mono', monospace;
  font-size: 12px;
  line-height: 1.45;
  white-space: pre;
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/QC/QCJobSubmitter.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yDAAwL;EACxL,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,SAAS;EACT,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4EAA4E;EAC5E,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/* QC Job Submitter Styles */\n\n.job-submitter {\n  background: white;\n  border-radius: 8px;\n  padding: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  max-width: 700px;\n}\n\n.job-submitter h2 {\n  margin-top: 0;\n  margin-bottom: 24px;\n  font-size: 20px;\n  color: #1f2937;\n}\n\n.job-form {\n  display: grid;\n  gap: 24px;\n}\n\n/* Fieldset */\n.job-submitter fieldset {\n  border: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: 16px;\n}\n\n.job-submitter legend {\n  display: block;\n  width: 100%;\n  padding: 12px 0;\n  margin: 0 -24px;\n  padding-left: 24px;\n  padding-right: 24px;\n  font-weight: 600;\n  font-size: 14px;\n  color: #374151;\n  background: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 8px;\n}\n\n/* Form Rows */\n.job-submitter .form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.job-submitter .form-row.single {\n  grid-template-columns: 1fr;\n}\n\n.job-submitter .form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.job-submitter .form-field.full-width {\n  grid-column: 1 / -1;\n}\n\n/* Labels */\n.job-submitter .form-field label {\n  font-weight: 500;\n  font-size: 13px;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Input Fields */\n.job-submitter .input-field {\n  padding: 10px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 13px;\n  font-family: inherit;\n  transition: all 0.2s ease;\n}\n\n.job-submitter .input-field:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.job-submitter .input-field:disabled {\n  background: #f3f4f6;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.job-submitter textarea.input-field {\n  resize: vertical;\n  min-height: 80px;\n  font-family: inherit;\n}\n\n.job-submitter select.input-field {\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23374151' d='M1 1l5 5 5-5'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  padding-right: 32px;\n}\n\n/* Form Buttons */\n.job-submitter .form-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-start;\n}\n\n.job-submitter .btn-secondary {\n  flex: 1;\n  white-space: nowrap;\n}\n\n/* Expand Button */\n.job-submitter .btn-expand {\n  width: 100%;\n  margin: 0;\n  font-size: 13px;\n  padding: 12px;\n  background: white;\n  color: #667eea;\n  border: 1px solid #e5e7eb;\n  text-align: left;\n  border-radius: 6px;\n}\n\n.job-submitter .btn-expand:hover {\n  background: #f9fafb;\n  border-color: #667eea;\n}\n\n/* Messages */\n.job-submitter .alert {\n  padding: 12px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  margin: 0;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .job-submitter {\n    padding: 16px;\n  }\n\n  .job-submitter legend {\n    margin-left: -16px;\n    margin-right: -16px;\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .job-submitter .form-row {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .job-submitter .form-buttons {\n    flex-direction: column;\n  }\n\n  .job-submitter .btn-secondary {\n    margin: 0;\n  }\n}\n\n/* Inline rules editor */\n.form-hint {\n  margin: 0 0 12px 0;\n  font-size: 12px;\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.form-hint-inline {\n  font-weight: normal;\n  font-size: 11px;\n  color: #9ca3af;\n  margin-left: 6px;\n}\n\n.input-field.mono {\n  font-family: 'SFMono-Regular', Menlo, Consolas, 'Liberation Mono', monospace;\n  font-size: 12px;\n  line-height: 1.45;\n  white-space: pre;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
